import s from './style.module.scss';
import { Display } from '@/components/Display/Display';
import { useState } from 'react';
// import choseImg from '@/assets/images/web/courseRecommend/chose.png';
import moment from 'moment';
import GrtButton from '@/components/Mobile/GrtButton';
import { CloseOutline } from 'antd-mobile-icons';
import { secondCheck } from '@/utils/Page/courseRecommend';
const getTime = (end_state, start_time, end_time) => {
    if (end_state === 2) {
        return '长期有效';
    }
    if (start_time && end_time) {
        return moment(start_time).format('YYYY-MM-DD HH:mm:ss') + ' 至 ' + moment(end_time).format('YYYY-MM-DD HH:mm:ss');
    }
    return null;
};
const ChoseCourse = (props) => {
    const [choseItem, setChoseItem] = useState({}); //当前选择的
    const { list, resource_id, onClose } = props;
    const onClick = async () => {
        let data = {
            resource_id,
            business_id: choseItem.business_id,
            template_id: choseItem.template_id
        };
        console.log(data, 'data');
        let res = await secondCheck(data, 'mobile');
        if (res) {
            onClose();
        }
    };
    return (
        <div className={s['chose-list-box']}>
            <div className={s['all-title']}>
                <div className={s['left']}>选择视频</div>
                <span onClick={onClose}>
                    <CloseOutline />
                </span>
            </div>
            <div className={s['tip-text']}>该视频存在{list.length}个视频课下，请任选一个进行学习</div>
            <div className={s['chose-list-wrap']}>
                {list.map((ele, index) => {
                    return (
                        <div
                            key={index}
                            onClick={() => {
                                setChoseItem(ele);
                            }}
                            className={s['chose-item']}
                            data-active={choseItem.business_id === ele.business_id}
                        >
                            <Display show={choseItem.business_id === ele.business_id}>
                                {/* <img className={s['check-img']} src={choseImg} alt="" /> */}
                                <div className={s['check-img']}></div>
                            </Display>
                            <div className={s['catetory-wrap']}>
                                {ele?.category_list.map((item, idx) => {
                                    return (
                                        <span key={idx} data-type={ele.template_id} className={s['category']}>
                                            {item.name}
                                        </span>
                                    );
                                })}
                            </div>
                            <div className={s['title']}>{ele.title}</div>
                            <div className={s['time']}>{getTime(ele.end_state, ele.start_time, ele.end_time) || ''}</div>
                        </div>
                    );
                })}
            </div>
            <div style={{ textAlign: 'center' }}>
                <GrtButton disabled={!choseItem.business_id} onClick={onClick} className={s['chose-button']} color="primary">
                    确定
                </GrtButton>
            </div>
        </div>
    );
};

export default ChoseCourse;
